import React, { useCallback } from 'react';
import c from 'classnames';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import EditorIconButton from '../_partials/EditorIconButton';
import s from './buttons.scss';
const SliderPrev = ({ onClick, className, editor })=>{
    const handleClick = useCallback((e)=>{
        onClick(e);
        editor.chain().focus().run();
    }, [
        editor,
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "action:left",
        icon: ArrowLeft,
        className: c(s['slider-button'], s['left'], className),
        onClick: handleClick,
        /**
       * We can hide these from screen readers because they have
       * access to all of the slider content without these buttons
       */ "aria-hidden": 'true',
        // Just to satisfy typings
        "aria-label": "hidden"
    });
};
SliderPrev.displayName = 'SliderPrevButton';
export default SliderPrev;

//# sourceMappingURL=SliderPrev.js.map